import { VOICIFY_EMAIL_STORE } from '../constants/Keys';
import User from '../models/user/User';

export const isVoicifyEmail = (email?: string | null): boolean => {
    return email?.toLowerCase().endsWith('@voicify.com') ?? false;
};

export const getCurrentUserEmail = (currentUser?: User | null): string | null => {
    if (currentUser?.email?.length) {
        return currentUser.email;
    }

    if (typeof window === 'undefined') {
        return null;
    }

    return localStorage.getItem(VOICIFY_EMAIL_STORE);
};

export const isVoicifyUser = (currentUser?: User | null): boolean => {
    return isVoicifyEmail(getCurrentUserEmail(currentUser));
};
